import type { SubjectOption } from './impact-of-disability_types'
import { getAreasOfNeed } from '@/presentlevels/api_v1.js'
import { useVisibilityStore } from '@/visibility/visibility.store'
import { storeToRefs } from 'pinia'

// The v1 template statements the non-AI mode composes from have no Behavior entries.
const AI_ONLY_IOD_SUBJECTS: readonly string[] = ['Behavior']

export function getIODSubjects(): SubjectOption[] {
  const { selVisibility } = storeToRefs(useVisibilityStore())
  return getAreasOfNeed({ iodSubject: true, selBlocked: !selVisibility.value })
}

export function getNonAIIODSubjects(): SubjectOption[] {
  return getAreasOfNeed({ iodSubject: true, selBlocked: false }).filter(
    (subject: SubjectOption) => !AI_ONLY_IOD_SUBJECTS.includes(subject.value)
  )
}
